const { Flickity, jQuery: $ } = window;

// TODO: add padding-top to module under this one on mobile
class Hero {
	constructor() {
		this.container = $( '.hero' );
		this.slides = this.container.find( '.hero-slide' );
		this.nav = this.container.find( '.hero-nav' );
		this.navItems = this.nav.find( '.hero-nav-button' );
		this.flkty = null;

		// watch for changes on resize
		// only render on viewport >= 768px
		const observer = new ResizeObserver( ( entries ) => {
			const width = entries[ 0 ].contentRect.width;
			if ( width >= 768 && ! this.flkty ) {
				this.renderSlider();
			} else if ( width < 768 && this.flkty ) {
				this.destroySlider();
			}
			if ( width < 768 ) {
				this.handleMobilePadding();
			}
		} );

		observer.observe( document.body );
	}

	renderSlider() {
		if ( this.slides.length <= 1 ) {
			return;
		}

		// show all slides
		this.slides.removeClass( '!hidden' );

		// render slider
		this.flkty = new Flickity( this.container[ 0 ], {
			// options
			cellSelector: '.hero-slide',
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			pageDots: false,
		} );

		// add slider nav events
		this.handleSliderNav();
	}

	destroySlider() {
		// destroy slider
		this.flkty.destroy();
		this.flkty = null;

		// hide all slides except first slide
		this.slides.not( ':eq(0)' ).addClass( '!hidden' );
	}

	handleSliderNav() {
		// set active class to buttons when a new slide activates
		this.flkty.on( 'select', ( index ) => {
			const current = this.navItems.eq( index );

			// remove active class and disabled attr for old button
			this.navItems.removeClass( 'is-active' );
			this.navItems.removeAttr( 'disabled' );

			// set active class and disabled attr for new button
			current.addClass( 'is-active' );
			current.attr( 'disabled', true );
		} );

		// handle click events on nav buttons
		this.navItems.on( 'click', ( e ) => {
			const index = $( e.currentTarget ).index();
			this.flkty.select( index );
		} );
	}

	handleMobilePadding() {
		const content = this.container.find( '.hero-content' );
		const height = content.outerHeight();
		const offset = height - ( this.container.height() - content.position().top );
		this.container.next().addClass('pt-dynamic md:pt-0').css( '--dynamic-pt', `${ offset }px` );
	}
}

new Hero();

